// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"616":"9b35caacb45f65dc","888":"86fcc5435bb3607b"}[chunkId] + ".css";
};